const addQueryParamToUrl = ({ url, key, value })=>{
    const splittedUrl = url.split(/\?(.+)/);
    const baseUrl = splittedUrl[0];
    const currentQueryParams = splittedUrl[1];
    return `${baseUrl}?${currentQueryParams ? `${currentQueryParams}&` : ''}${key}=${value}`;
};
const addQueryParamToUrl_addQueryParamToUrl = addQueryParamToUrl;
export default addQueryParamToUrl_addQueryParamToUrl;
